import { createAction } from '@reduxjs/toolkit'

import { TAnalysisTypeResponse } from 'redux/api/AnalysisTypes'

// tryGetAllAnalysisTypes
export const getAll = createAction('get_all_analysis_types')
export const getAllSuccess = createAction<TAnalysisTypeResponse[]>(
  'get_all_analysis_types_success'
)
export const getAllFailed = createAction('get_all_analysis_types_failed')

// tryGetAnalysisTypeRealEstates
export const getRealEstates = createAction('get_analysis_type_real_estates')
export const getRealEstatesSuccess = createAction<string[]>(
  'get_analysis_type_real_estates_success'
)
export const getRealEstatesFailed = createAction(
  'get_analysis_type_real_estates_failed'
)

// tryUpdateAnalysisTypeSettings
export const updateSettings = createAction('update_analysis_type_settings')
export const updateSettingsSuccess = createAction<TAnalysisTypeResponse>(
  'update_analysis_type_settings_success'
)
export const updateSettingsFailed = createAction(
  'update_analysis_type_settings_failed'
)
